module.exports = __webpack_public_path__ + "cement/img/图像 303@2x.956c7e9b.png";